module.exports = __webpack_public_path__ + "static/media/iconClose.7bda9f39.svg";